import { client, deserializeJSONString } from '@trello/graphql';
// eslint-disable-next-line no-restricted-imports
import { Action, actionCreator } from '@trello/redux';

// eslint-disable-next-line no-restricted-imports
import { CardResponse } from 'app/gamma/src/types/responses';
import { StandardThunkAction } from '../../types';
import {
  LoadCanonicalCardDocument,
  LoadCanonicalCardQuery,
  LoadCanonicalCardQueryVariables,
} from './LoadCanonicalCardQuery.generated';
import { featureFlagClient } from '@trello/feature-flag-client';

// eslint-disable-next-line no-restricted-imports
import { Dispatch } from 'app/gamma/src/types';

// Action types
export const LOAD_CARD_REQUEST = Symbol('loaders/LOAD_CARD_REQUEST');
export const LOAD_CARD_SUCCESS = Symbol('loaders/LOAD_CARD_SUCCESS');
export const LOAD_CARD_ERROR = Symbol('loaders/LOAD_CARD_ERROR');

export type LoadCardRequestAction = Action<typeof LOAD_CARD_REQUEST, string>;
export type LoadCardSuccessAction = Action<
  typeof LOAD_CARD_SUCCESS,
  CardResponse
>;
export type LoadCardErrorAction = Action<typeof LOAD_CARD_ERROR, Error>;

// Action creators
const loadCardRequest = actionCreator<LoadCardRequestAction>(LOAD_CARD_REQUEST);
const loadCardSuccess = actionCreator<LoadCardSuccessAction>(LOAD_CARD_SUCCESS);
const loadCardError = actionCreator<LoadCardErrorAction>(LOAD_CARD_ERROR);

export const loadCanonicalCard = (idCard: string): StandardThunkAction => {
  return async (dispatch: Dispatch) => {
    dispatch(loadCardRequest(idCard));
    const { data, error } = await client.query<
      LoadCanonicalCardQuery,
      LoadCanonicalCardQueryVariables
    >({
      query: LoadCanonicalCardDocument,
      variables: {
        id: idCard,
      },
      fetchPolicy: featureFlagClient.get('fep.load-card-from-apollo', false)
        ? 'cache-first'
        : 'network-only',
      context: {
        operationName: 'LoadCanonicalCard',
        document: LoadCanonicalCardDocument,
      },
    });
    if (error) {
      dispatch(loadCardError(error));
    } else {
      const card = data.card;
      if (!card) {
        return;
      }
      const dataToDispatch = {
        ...card,
        descData: deserializeJSONString(card.descData),
      };

      dispatch(loadCardSuccess(dataToDispatch));
    }
  };
};
